//TODO: Determine reason for canvas drawing differences
var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.ImageCanvasSource = new Class({
    Extends: OCS.Viewer.Classes.AbstractSource,
    class_name: "ImageCanvasSource",
    canvas: null,
    ctx: null,
    canvas_draw_args: {size: [1, 1]},
    canvas_draw_timeout: null,
    drawn: false,
    palette: null,
    keep_data: true, // Setting for whether or not to keep data, prevents data deletion for image canvas sources
    draw_keep: false,
    options: {
        metadata: {
            source_type: 'ImageCanvas'
        },
        precision: 0
    },
    create: function (options) {
        if (!this.get_ol_object()) {
            this.set_ol_object(new ol.source.ImageCanvas(this.get_source_ops(options)));
        }
        return this.get_ol_object();
    },
    /**
     * draw
     * @param {ol.Extent} inExtent
     * @param {Number} inResolution
     * @param {Number} inPixelRatio
     * @param {ol.Size} inSize
     * @param {ol.proj.Projection} inProjection
     * @returns {image_canvas_sourceAnonym$0@call;create_canvas|Element|net.testL#6.net.testL#6#L#8.net.testL#6#L#8#L#26.element}
     */
    draw: function (inExtent, inResolution, inPixelRatio, inSize, inProjection) {
        this.draw_keep = true;
        clearTimeout(this.canvas_draw_timeout);
        this.canvas_draw_timeout = null;
        this.canvas_draw_args = {extent: inExtent, resolution: inResolution, pixel_ratio: inPixelRatio, size: inSize, projection: inProjection};
        if (!this.canvas_draw_timeout) {
            // Took this out as it caused the gradient to flash on and off. 
            //TODO: Look at possibly doing some sort of canvas manipulation to meet the conditions expected without doing a full re render
//            this.canvas_draw_timeout = setTimeout(function () {
//                this.canvas_draw_timeout = null;
            this.draw_method(this.get_canvas_info(inExtent));
//            }.bind(this), 0);
        }
        return this.get_canvas();
    },
    draw_method: function (canvas_info) {
        if (!canvas_info || canvas_info.map_origin === null || canvas_info.canvas_origin === null) {
            return;
        }
        this.clear_canvas();
        var pixel_delta = [canvas_info.map_origin[0] - canvas_info.canvas_origin[0], canvas_info.map_origin[1] - canvas_info.canvas_origin[1]];
        return this.draw_canvas(pixel_delta, canvas_info);
    },
    draw_canvas: function (pixel_delta, canvas_info) {
        // To be overrided
    },
    create_canvas: function () {
        if (!this.canvas) {
            this.canvas = document.createElement('canvas');
            this.canvas.setAttribute('width', this.canvas_draw_args.size[0]);
            this.canvas.setAttribute('height', this.canvas_draw_args.size[1]);
            this.ctx = this.canvas.getContext('2d');
            this.ctx.scale(this.canvas_draw_args.pixel_ratio, this.canvas_draw_args.pixel_ratio);
        }
        return this.canvas;
    },
    clear_canvas: function () {
        if (this.canvas) {
            this.canvas = null;
            this.ctx = null;
        }
        var context = this.get_context();
        context.clearRect(0, 0, this.canvas_draw_args.size[0], this.canvas_draw_args.size[1]);
    },
    get_canvas: function () {
        if (!this.canvas) {
            this.create_canvas();
        }
        return this.canvas;
    },
    get_context: function () {
        if(!this.canvas) {
            this.create_canvas();
        }
        return this.ctx;
    },
    get_canvas_info: function () {

    },
    get_data_obj: function () {
        var data;
        var metadata = this.options.metadata;
        if (!this.data || !Object.keys(this.data).length) {
            var storage_key = this.get_storage_key(metadata.dataset, metadata.grid, metadata.timestamp_epoch, [{parm: metadata.variables[0].parm, units: metadata.variables[0].site}]);
            data = this.get_stored_data(storage_key);
            if (data && data.class_type === "Data" && (this.keep_data || this.draw_keep)) {
                this.data = data;
            }
        } else {
            data = this.data;
            // Do we need to keep the data for some reason?
            if (!this.keep_data && !this.draw_keep) {
                this.data = {};
            }
        }
        if (!data || !data.data) {
            console.error('No data found!', data, metadata);
        }
        return data;
    },
    get_data: function () {
        var data = this.get_data_obj();
        if (data) {
            return data.data();
        }
        return false;
    },
    get_json_data: function () {
        var data = this.get_data_obj();
        return data.json();
    },
    get_pixel_from_coordinate: function () {

    },
    set_data: function (data) {
        if (this.keep_data || this.draw_keep) {
            this.data = data;
        }
        this.set_data_avail();
    },
    set_palette: function (palette) {
        this.palette = palette;
    },
    get_palette: function () {
        if (!this.palette) {
            var pm = OCS.Viewer.Functions.get_palette_manager();
            var name = pm.get_palette_name_from_ops({parm: this.options.metadata.variables[0].parm, use_auto: this.options.init.auto, min_val: this.options.min_val, max_val: this.options.max_val});
            var palette = pm.get_palette(name);
            if (!palette) {
                palette = pm.get_palette(pm.get_palette_name_from_ops({'parm': this.options.metadata.variables[0].parm}));
                if (palette) {
                    palette = palette.clone();
                    palette.set_max_val(this.get_max_val());
                    palette.set_min_val(this.get_min_val());
                    pm.add_palette(name, palette);
                    this.set_palette(palette);
                }
            } else {
                this.set_palette(palette);
            }
        }
        return this.palette;
    },
    get_source_ops: function (options) {
        var ops = {
            projection: this.options.projection,
            canvasFunction: this.draw.bind(this)
        };

        return ops;
    },
    process_data_callback: function (input, data) {
        // We have managed to retrieve the data again, set off the event for displaying the new data.
        this.process_data(data);
    },
    valueFromCoordinate: function (inCoordinate) {
        var lonLat = ol.proj.transform(inCoordinate, OCS.Viewer.Config.default_projection, OCS.Viewer.Config.default_display_projection);
        return this.valueFromLonLat(lonLat);
    },
    valueFromLonLat: function (inLonLat) {

    },
    checkForRender: function (inResolution, inExtent) {
        var currentResolution = this.canvas_draw_args.resolution;
        var currentExtent = this.canvas_draw_args.extent;
        var needsRender = ((inResolution !== currentResolution) ||
                (inExtent[0] !== currentExtent[0]) ||
                (inExtent[1] !== currentExtent[1]) ||
                (inExtent[2] !== currentExtent[2]) ||
                (inExtent[3] !== currentExtent[3]));
        return needsRender;
    },
    getRenderedResolution: function () {
        return this.canvas_draw_args.resolution;
    },
    getRenderedExtent: function () {
        return this.canvas_draw_args.extent;
    },
    destroy: function () {
        this.palette = null;
        this.canvas = null;
        this.parent();
    }
});
